import { V2Button } from '@abyss/web/ui/Button';
import { Layout } from '@abyss/web/ui/Layout';
import { V2ModalDialog } from '@abyss/web/ui/ModalDialog';
import { find } from 'lodash';
import { useTranslation } from 'react-i18next';

import { ConstantsLagoon } from '../../../common/ConstantsLagoon';
import { useLagoon } from '../../../hooks/useLagoon';

type Props = {
  handleClose: () => void;
  handleLogin: () => void;
};

export const GuestTimeoutModal = ({ handleClose, handleLogin }: Props) => {
  const { t } = useTranslation();

  const data = useLagoon('ui-messaging')();

  const guestTimeoutModalBodyText = find(data, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.GUEST_TIMEOUT_MODAL_BODY,
  })?.message;

  return (
    <V2ModalDialog
      closeOnClickOutside={false}
      data-auto-testid="guest-timeout-modal"
      data-testid="guest-timeout-modal"
      footer={
        <Layout.Group alignLayout="right">
          <V2Button
            data-auto-testid="timeout-modal-start-new-session"
            data-testid="timeout-modal-start-new-session"
            onClick={handleClose}
          >
            {t('INACTIVITY_MODAL.START_NEW_SESSION')}
          </V2Button>
          <V2Button
            data-auto-testid="timeout-modal-sign-in"
            data-testid="timeout-modal-sign-in"
            onClick={handleLogin}
            variant="outline"
          >
            {t('INACTIVITY_MODAL.SIGN_IN')}
          </V2Button>
        </Layout.Group>
      }
      header={t('INACTIVITY_MODAL.TITLE_SESSION_ENDED')}
      isOpen
      onClose={handleClose}
    >
      {guestTimeoutModalBodyText}
    </V2ModalDialog>
  );
};
